/**
 * Identity
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { InternalRoleTenant } from './internal-role-tenant';


export interface RolesByCodesResponse { 
    id?: string;
    name?: string | null;
    isSystem?: boolean;
    code?: string | null;
    tenant?: InternalRoleTenant;
    permissionIds?: Array<string> | null;
}

